import React from 'react'
import { observer } from 'mobx-react'

import Dialog from 'components/dialog/Dialog'
import Button from 'components/button/Button'

import styles from './tabCloseConfirmDialog.scss'

interface IProps {
  onCancel: () => void
  onDiscard: () => void
}

class TabCloseConfirmDialog extends React.Component<IProps> {
  render() {
    const { onCancel, onDiscard } = this.props
    return (
      <Dialog
        className={styles.container}
        title="Discard changes?"
        primaryButton={
          <Button data-cy="tab__discard--discard" red onClick={onDiscard}>
            Discard
          </Button>
        }
        secondaryButton={
          <Button
            data-cy="tab__discard--cancel"
            ghost
            className={styles.cancelBtn}
            onClick={onCancel}
          >
            Cancel
          </Button>
        }
      >
        <div className={styles.content}>
          <p className={styles.description}>
            This tab contains unsaved changes. Do you want to discard them?
          </p>
        </div>
      </Dialog>
    )
  }
}

export default observer(TabCloseConfirmDialog)
